import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Card, Descriptions, Divider, Flex, Form, message, Skeleton, Space, Tooltip, Typography } from 'antd';
import ProductFamilyModal from '../../../components/certificate/productFamilyModal';
import AntdLink from 'antd/es/typography/Link';
import _ from 'lodash';
import certificateService from '../../../services/certificateService';
import { DeleteOutlined, EditFilled, FileTextOutlined, SyncOutlined } from '@ant-design/icons';
import DirectCertRenewalModal from '../../../components/certificate/directCertRenewalModal';
import CertLinkRenewalModal from '../../../components/certificate/certLinkRenewalModal';
import { Link, useNavigate, useParams } from 'react-router-dom';
import CertDeleteConfrim from '../../../components/certificate/certDeleteConfrim';
import { useSelector } from 'react-redux';
import { DownloadDocument, formatDate, formatDateDisplay } from '../../../utils/commonUtil';
import CertificateDetailRLTable from '../../../components/certificate/certificateDetailRLTable';
import commonService from "../../../services/CommonService";
import { UserActivity } from "../../../config/BVConstants";
const { Text: AntdText } = Typography;
const CertificateDetails = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
    const [objCertDetails, setObjCertDetails] = useState();
    const [productFamilyList, setProductFamilyList] = useState([]);
    const [showFactoryRemark, setshowFactoryRemark] = useState(false);
    const [openProdFamilyDialog, setOpenProdFamilyDialog] = useState(false);
    const [loadingDesc, setLoadingDesc] = useState(true);
    const [regLibList, setRegLibList] = useState([]);
    const [openDirectCertRenewalDialog, setOpenDirectCertRenewalDialog] = useState(false);
    const [lstLinkedRenewalCertificate, setLstLinkedRenewalCertificate] = useState([]);
    const [openCertLinkRenewalDialog, setOpenCertLinkRenewalDialog] = React.useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [form] = Form.useForm();
    const { certUniqueId } = useParams();
    const [openCertDeleteConfrimDialog, setOpenCertDeleteConfrimDialog] = React.useState(false);
    const [intLinkUniqueCertificateId, setIntLinkUniqueCertificateId] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const applicationData = useSelector((state) => state.applicationData);
    const navigate = useNavigate();
    const boolScreenAccessCheck = ((_d = (_c = (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.getClientUserScreenAccess) === null || _a === void 0 ? void 0 : _a.lstClientUserCompanies) === null || _b === void 0 ? void 0 : _b.find((obj) => { var _a, _b; return obj.intId === ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID); })) === null || _c === void 0 ? void 0 : _c.lstObjLuScreens) === null || _d === void 0 ? void 0 : _d.find((obj) => obj.intId === 3)) != undefined;
    useEffect(() => {
        var _a, _b, _c, _d;
        if (!boolScreenAccessCheck) {
            navigate('/no-access');
            return;
        }
        else if ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId) {
            commonService
                .logUserActivity((_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.strUserEmailId, UserActivity.CP__Cert_Detail_Visited);
        }
    }, []);
    useEffect(() => {
        if (certUniqueId) {
            const objCert = { intUniqueCertificateId: parseInt(atob(certUniqueId)) };
            certificateService
                .getCertificateDetails(objCert)
                .then((res) => {
                setObjCertDetails(res);
                setLoadingDesc(false);
                let regMpFilter = {
                    objLuCountry: _.get(res, 'objLuCountry'),
                    objTblService: _.get(res, 'objTblService'),
                    intFirstPage: pagination.current,
                    intPageSize: pagination.pageSize
                };
                getRegLibCertMpCount(regMpFilter);
                getRegLibCertMpLazy(regMpFilter);
            });
        }
    }, [certUniqueId]);
    function getRegLibCertMpCount(regMpFilter) {
        certificateService
            .getApiRegLibCertMpCount(regMpFilter)
            .then((res) => {
            setPagination(prev => (Object.assign(Object.assign({}, prev), { total: res })));
        });
    }
    function getRegLibCertMpLazy(regMpFilter) {
        certificateService
            .getApiRegLibCertMpLazy(regMpFilter)
            .then((res) => {
            setRegLibList(res);
            setIsLoading(false);
        });
    }
    function getProductFamilyList(certDetails) {
        if ((certDetails === null || certDetails === void 0 ? void 0 : certDetails.intIACert) === 2) {
            certificateService
                .getClientDirectCertProductFamily(certDetails.strProjectId)
                .then((res) => {
                // Adjust the type of 'res' according to your API response
                for (const prod of res) {
                    if (prod.strRemarks) {
                        setshowFactoryRemark(true);
                    }
                }
                setProductFamilyList(res);
            });
        }
        else {
            certificateService.getCertProductFamily(certDetails.strUniqueId).then((res) => {
                // Adjust the type of 'res' according to your API response
                for (const prod of res) {
                    if (prod.strRemarks) {
                        setshowFactoryRemark(true);
                    }
                }
                setProductFamilyList(res);
            });
        }
    }
    const handleProdFamilyDialog = (certDetails) => {
        getProductFamilyList(certDetails);
        setOpenProdFamilyDialog(true);
    };
    const brandNameContent = (certDetails) => {
        var _a, _b;
        return certDetails.boolSingleCert ? (_jsx(AntdLink, { onClick: () => handleProdFamilyDialog(certDetails), children: (_a = certDetails === null || certDetails === void 0 ? void 0 : certDetails.objBrandName) === null || _a === void 0 ? void 0 : _a.strLongDesc })) : ((_b = certDetails === null || certDetails === void 0 ? void 0 : certDetails.objBrandName) === null || _b === void 0 ? void 0 : _b.strLongDesc);
    };
    // const DownloadCertificate = (strDocRefId: String | undefined): void => {
    //   certificateService.getFileDocument(strDocRefId).then((res) => {
    //     if(res?.bytefileData){
    //     let typeOfFile;
    //     if (res?.strDocName?.includes('.pdf')) {
    //       typeOfFile = { type: 'application/pdf' };
    //     } else {
    //       typeOfFile = { type: 'application/*' };
    //     }
    //     //Convert the bytefileData to a Blob
    //     const blob = new Blob([new Uint8Array(res?.bytefileData)], typeOfFile);
    //     // Create a download link for the Blob
    //     const downloadUrl = URL.createObjectURL(blob);
    //     if (res?.strDocName?.includes('.zip')) {
    //       let a = document.createElement('a');
    //       a.href = downloadUrl;
    //       a.download = res?.strDocName;
    //       a.click();
    //     } else if (res?.strDocName?.includes('.pdf')) {
    //       window.open(downloadUrl);
    //     }
    //   }else{
    //     message.error('No documents Available to download');
    //   }
    // }
    // );
    // };
    const certificateDownload = (certDetails, certType) => {
        var _a, _b, _c, _d;
        return _jsxs(_Fragment, { children: [certType === "CurrentCert" ?
                    _jsxs(_Fragment, { children: [_jsx(FileTextOutlined, { onClick: () => DownloadDocument(certDetails === null || certDetails === void 0 ? void 0 : certDetails.strDocRefId) }), "\u00A0", certDetails === null || certDetails === void 0 ? void 0 : certDetails.strCertId] })
                    : "", certType === "CurrentToCert" ?
                    _jsxs(_Fragment, { children: [_jsx(FileTextOutlined, { onClick: () => { var _a; return DownloadDocument((_a = certDetails === null || certDetails === void 0 ? void 0 : certDetails.objRenewedFromCert) === null || _a === void 0 ? void 0 : _a.strDocRefId); } }), _jsxs(Link, { to: `/certificates/details/${((_a = certDetails === null || certDetails === void 0 ? void 0 : certDetails.objRenewedToCert) === null || _a === void 0 ? void 0 : _a.intUniqueCertificateId) ? btoa(certDetails.objRenewedToCert.intUniqueCertificateId.toString()) : ''}`, children: ["\u00A0", (_b = certDetails === null || certDetails === void 0 ? void 0 : certDetails.objRenewedToCert) === null || _b === void 0 ? void 0 : _b.strCertId] })] })
                    : "", certType === "CurrentFromCert" ?
                    _jsxs(_Fragment, { children: [_jsx(FileTextOutlined, { onClick: () => { var _a; return DownloadDocument((_a = certDetails === null || certDetails === void 0 ? void 0 : certDetails.objRenewedFromCert) === null || _a === void 0 ? void 0 : _a.strDocRefId); } }), _jsxs(Link, { to: `/certificates/details/${((_c = certDetails === null || certDetails === void 0 ? void 0 : certDetails.objRenewedFromCert) === null || _c === void 0 ? void 0 : _c.intUniqueCertificateId) ? btoa(certDetails.objRenewedFromCert.intUniqueCertificateId.toString()) : ''}`, children: ["\u00A0", (_d = certDetails === null || certDetails === void 0 ? void 0 : certDetails.objRenewedFromCert) === null || _d === void 0 ? void 0 : _d.strCertId] })] })
                    : ""] });
    };
    const loadingItems = [];
    const skeletonItem = {
        label: _jsx(Skeleton.Input, { active: true, size: 'default' }),
        children: _jsx(Skeleton.Input, { active: true, size: 'default' }),
        span: { xl: 2, xxl: 2 }
    };
    for (let i = 0; i < 10; i++) {
        loadingItems.push(skeletonItem);
    }
    const items = [];
    if (objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strServiceName) {
        items.push({
            key: '1',
            label: 'Certificate Name:',
            children: objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strServiceName,
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if ((_e = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objLuCountry) === null || _e === void 0 ? void 0 : _e.strLongDesc) {
        items.push({
            key: '2',
            label: 'Country/Territory:',
            children: (_f = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objLuCountry) === null || _f === void 0 ? void 0 : _f.strLongDesc,
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if (objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strCertId) {
        items.push({
            key: '3',
            label: 'Certificate Id:',
            children: certificateDownload(objCertDetails, "CurrentCert"),
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if ((_g = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objBrandName) === null || _g === void 0 ? void 0 : _g.strLongDesc) {
        items.push({
            key: '4',
            label: 'Brand/OEM:',
            children: brandNameContent(objCertDetails),
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if ((_h = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objCertStatus) === null || _h === void 0 ? void 0 : _h.strLongDesc) {
        items.push({
            key: '5',
            label: 'Certificate Status:',
            children: (_j = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objCertStatus) === null || _j === void 0 ? void 0 : _j.strLongDesc,
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if (objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strSeriesModel) {
        items.push({
            key: '6',
            label: 'Product Model:',
            children: objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strSeriesModel,
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if (objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.dtCertDate) {
        items.push({
            key: '7',
            label: 'Issue Date:',
            children: formatDateDisplay(objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.dtCertDate),
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if ((_l = (_k = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objTblService) === null || _k === void 0 ? void 0 : _k.objLuServiceCode) === null || _l === void 0 ? void 0 : _l.strLongDesc) {
        items.push({
            key: '8',
            label: 'Service Type:',
            children: (_o = (_m = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objTblService) === null || _m === void 0 ? void 0 : _m.objLuServiceCode) === null || _o === void 0 ? void 0 : _o.strLongDesc,
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if (objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.dtCertExpDate) {
        items.push({
            key: '9',
            label: 'Expiration Date:',
            children: formatDateDisplay(objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.dtCertExpDate),
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if ((_q = (_p = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objTblService) === null || _p === void 0 ? void 0 : _p.objLuProductMainType) === null || _q === void 0 ? void 0 : _q.strLongDesc) {
        items.push({
            key: '10',
            label: 'Product Category:',
            children: (_s = (_r = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objTblService) === null || _r === void 0 ? void 0 : _r.objLuProductMainType) === null || _s === void 0 ? void 0 : _s.strLongDesc,
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if ((_t = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objCertRenewalStatus) === null || _t === void 0 ? void 0 : _t.strLongDesc) {
        items.push({
            key: '11',
            label: 'Renewal Status:',
            children: (_u = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objCertRenewalStatus) === null || _u === void 0 ? void 0 : _u.strLongDesc,
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if ((_w = (_v = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objTblService) === null || _v === void 0 ? void 0 : _v.objLuProductType) === null || _w === void 0 ? void 0 : _w.strLongDesc) {
        items.push({
            key: '12',
            label: 'Product Sub Segment:',
            children: (_y = (_x = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objTblService) === null || _x === void 0 ? void 0 : _x.objLuProductType) === null || _y === void 0 ? void 0 : _y.strLongDesc,
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if (objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.dtRenewalDate) {
        items.push({
            key: '13',
            label: 'Recommended Decision Date:',
            children: formatDateDisplay(objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.dtRenewalDate),
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if ((_0 = (_z = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objEEMaster) === null || _z === void 0 ? void 0 : _z.objBusinessUnit) === null || _0 === void 0 ? void 0 : _0.strBusinessUnitName) {
        items.push({
            key: '14',
            label: 'BV Location:',
            children: (_2 = (_1 = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objEEMaster) === null || _1 === void 0 ? void 0 : _1.objBusinessUnit) === null || _2 === void 0 ? void 0 : _2.strBusinessUnitName,
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if (objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strFactory) {
        items.push({
            key: '15',
            label: 'Factory/Importer/OEM:',
            children: objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strFactory,
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if (objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strLab) {
        items.push({ key: '16', label: 'Lab:', children: objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strLab, span: { xl: 2, xxl: 2 } });
    }
    if ((_3 = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objRenewedToCert) === null || _3 === void 0 ? void 0 : _3.strCertId) {
        items.push({
            key: '17',
            label: 'Renewal Certificate ID:',
            children: certificateDownload(objCertDetails, "CurrentToCert"),
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if ((_4 = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objRenewedFromCert) === null || _4 === void 0 ? void 0 : _4.strCertId) {
        items.push({
            key: '18',
            label: 'Previous Certificate ID:',
            children: certificateDownload(objCertDetails, "CurrentFromCert"),
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    if (objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strCertificateHolder) {
        items.push({
            key: '19',
            label: 'Certificate Holder:',
            children: objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strCertificateHolder,
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    const isDisabled = !((_5 = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _5 === void 0 ? void 0 : _5.boolCertificateDetailsRequirementSummaryLink);
    const Text = ({ children, style }) => {
        return _jsx(AntdText, { style: style, children: children });
    };
    if (objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strRegulatorName) {
        items.push({
            label: 'Regulatory Specification:',
            children: (_jsx(_Fragment, { children: isDisabled ? (_jsx(Text, { style: { opacity: 0.2, color: 'gray' }, children: _jsx(Tooltip, { title: "Please Upgrade Membership.", children: objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strRegulatorName }) })) : (_jsx(Link, { to: `/regulation-information/details/${(objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strRegulationId) ? btoa((objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strRegulationId) + '-' + (objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.intRegVersion)) : null}`, target: "_blank", rel: "noopener noreferrer", children: objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strRegulatorName })
                //<Text>{objCertDetails?.strRegulatorName}</Text>
                ) })),
            span: { xl: 2, xxl: 2 },
            style: { width: '25%' }
        });
    }
    const directRenewalCert = (certDetails) => {
        setOpenDirectCertRenewalDialog(true);
        getProductFamilyList(certDetails);
    };
    const linkRenewalCert = () => {
        certificateService
            .getLinkedRenewalCertificate(objCertDetails)
            .then((res) => {
            if ((res === null || res === void 0 ? void 0 : res.length) > 0) {
                setLstLinkedRenewalCertificate(res);
                // setRadioSelLinkedCertificate(0);
                setOpenCertLinkRenewalDialog(true);
                // setDisableLinkCertButton(true);
            }
            else {
                form.resetFields();
                directRenewalCert(objCertDetails);
            }
        })
            .catch((error) => {
        });
    };
    const get_file_array = (file) => {
        const reader = new FileReader();
        return new Promise((resolve, reject) => {
            reader.onload = (event) => {
                if (event.target) {
                    resolve(event.target.result);
                }
                else {
                    reject(new Error('File reading failed'));
                }
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsArrayBuffer(file);
        });
    };
    const onFinish = (values) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        const objCreateNewCert = {
            objCreatedBy: { objUser: { intId: (_b = (_a = applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID } }
        };
        const objCreateRenewalCert = JSON.parse(JSON.stringify(values));
        delete objCreateRenewalCert.certUpload;
        objCreateRenewalCert['strAction'] = 'RENEWAL';
        objCreateRenewalCert['intIACert'] = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.intIACert;
        objCreateRenewalCert['intRenewalCertUniqueId'] = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.intUniqueCertificateId;
        (objCreateRenewalCert['strProductName'] = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strProductName),
            (objCreateRenewalCert['strProductModel'] = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.strSeriesModel),
            (objCreateRenewalCert['objBrandName'] = {
                strLongDesc: (_c = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objBrandName) === null || _c === void 0 ? void 0 : _c.strLongDesc
            }),
            (objCreateRenewalCert['objLuCountry'] = {
                intId: (_d = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objLuCountry) === null || _d === void 0 ? void 0 : _d.intId,
                strLongDesc: (_e = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objLuCountry) === null || _e === void 0 ? void 0 : _e.strLongDesc
            });
        objCreateRenewalCert['objLuServiceCode'] = {
            intId: (_g = (_f = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objTblService) === null || _f === void 0 ? void 0 : _f.objLuServiceCode) === null || _g === void 0 ? void 0 : _g.intId,
            strLongDesc: (_j = (_h = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objTblService) === null || _h === void 0 ? void 0 : _h.objLuServiceCode) === null || _j === void 0 ? void 0 : _j.strLongDesc
        };
        objCreateRenewalCert['objLuProductType'] = {
            intId: (_l = (_k = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objTblService) === null || _k === void 0 ? void 0 : _k.objLuProductType) === null || _l === void 0 ? void 0 : _l.intId,
            strLongDesc: (_o = (_m = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objTblService) === null || _m === void 0 ? void 0 : _m.objLuProductType) === null || _o === void 0 ? void 0 : _o.strLongDesc
        };
        objCreateRenewalCert['objLuTechnologyType'] = {
            intId: (_q = (_p = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objTblService) === null || _p === void 0 ? void 0 : _p.objLuTechnologyType) === null || _q === void 0 ? void 0 : _q.intId,
            strLongDesc: (_s = (_r = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objTblService) === null || _r === void 0 ? void 0 : _r.objLuTechnologyType) === null || _s === void 0 ? void 0 : _s.strLongDesc
        };
        objCreateRenewalCert['dtCertIssueDate'] = formatDate(new Date(values.dtCertIssueDate));
        objCreateRenewalCert['dtCertExpirationDate'] = formatDate(new Date(values.dtCertExpirationDate));
        objCreateRenewalCert['objLuRequestType'] = {
            intId: 2
        };
        if (objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.boolSingleCert) {
            objCreateRenewalCert['objCertificateSeriesBrand'] = productFamilyList === null || productFamilyList === void 0 ? void 0 : productFamilyList.map(val => ({
                strSeriesModal: val.strSeriesModel,
                objBrandName: val.objBrandName,
            }));
            objCreateRenewalCert['intSingleCertificate'] = 1;
            objCreateNewCert['intSingleCertificate'] = 1;
        }
        else {
            objCreateRenewalCert['intSingleCertificate'] = 0;
            objCreateNewCert['intSingleCertificate'] = 0;
        }
        const formData = new FormData();
        formData.append('file', values.certUpload[0].originFileObj);
        formData.append('strPathType', 'DIRECT_CERT_UPLOAD');
        certificateService
            .saveDocument(formData)
            .then((res) => {
            objCreateRenewalCert['strDocRefId'] = res;
            objCreateNewCert['lstNewCertificateUploadClient'] = [objCreateRenewalCert];
            certificateService
                .saveClientCertUpload(objCreateNewCert)
                .then((res) => {
                var _a, _b;
                const uniqueCertificateId = res.lstNewCertificateUploadClient[0].intCertUniqueId;
                if (uniqueCertificateId) {
                    const url = `/certificates/details/${btoa(uniqueCertificateId.toString())}`;
                    navigate(url);
                }
                setOpenDirectCertRenewalDialog(false);
                commonService
                    .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__Cert_Renewal_Created);
            })
                .catch((error) => {
            });
        }).catch((error) => {
            var _a;
            message.error((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data);
        });
    };
    const handleUpdateCertificate = () => {
        const url = `/certificates/update-certificate-information/${(objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.intUniqueCertificateId) ? btoa(objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.intUniqueCertificateId.toString()) : ''}`;
        navigate(url);
    };
    const deleteCertificate = () => {
        setOpenCertDeleteConfrimDialog(true);
    };
    const handleDeleteCertificate = () => {
        certificateService.deleteApprCertUploadInfo(objCertDetails).then((res) => {
            setOpenCertDeleteConfrimDialog(false);
            navigate('/certificates');
        });
    };
    const openDirectRenewalCert = () => {
        setOpenCertLinkRenewalDialog(false);
        setOpenDirectCertRenewalDialog(true);
    };
    const updateLinkedRenewalStatus = () => {
        const objCertNotification = {
            intIACert: objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.intIACert,
            intUniqueCertificateId: intLinkUniqueCertificateId,
            intRenewalCertUniqueId: objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.intUniqueCertificateId
        };
        certificateService
            .updateLinkedRenewalStatus(objCertNotification)
            .then((res) => {
            const uniqueCertificateId = res.intUniqueCertificateId;
            if (uniqueCertificateId) {
                const url = `/certificates/details/${btoa(uniqueCertificateId.toString())}`;
                navigate(url);
            }
            setOpenCertLinkRenewalDialog(false);
        })
            .catch((error) => {
        });
    };
    const onRowSelection = (selectedRowKeys, selectedRows) => {
        const particularId = selectedRows[0].intUniqueCertificateId;
        setIntLinkUniqueCertificateId(particularId);
    };
    const handleTableChange = (pagination) => {
        setIsLoading(true);
        setPagination(prev => (Object.assign(Object.assign({}, prev), { current: pagination.current, pageSize: pagination.pageSize })));
        getRegLibCertMpLazy({
            objLuCountry: _.get(objCertDetails, 'objLuCountry'),
            objTblService: _.get(objCertDetails, 'objTblService'),
            intFirstPage: pagination.current * pagination.pageSize - pagination.pageSize,
            intPageSize: pagination.current * pagination.pageSize
        });
    };
    return (_jsxs(Card, { children: [_jsx(ProductFamilyModal, { open: openProdFamilyDialog, onClose: () => setOpenProdFamilyDialog(false), productFamilyList: productFamilyList, isRemark: showFactoryRemark }), _jsx(DirectCertRenewalModal, { open: openDirectCertRenewalDialog, onClose: () => setOpenDirectCertRenewalDialog(false), productFamilyList: productFamilyList, data: objCertDetails, form: form, onFinish: onFinish }), _jsx(CertLinkRenewalModal, { open: openCertLinkRenewalDialog, selection: setSelectedRowKeys, openDirectRenewalCert: openDirectRenewalCert, updateLinkedRenewalStatus: updateLinkedRenewalStatus, onRowSelection: onRowSelection, onClose: () => setOpenCertLinkRenewalDialog(false), data: lstLinkedRenewalCertificate }), _jsx(CertDeleteConfrim, { open: openCertDeleteConfrimDialog, onClose: () => setOpenCertDeleteConfrimDialog(false), handleDeleteCertificate: handleDeleteCertificate }), ((_6 = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _6 === void 0 ? void 0 : _6.boolCertificateDetailsViewCertificateInformation) &&
                _jsx(Descriptions, { title: "Certificate Information", extra: _jsx(_Fragment, { children: _jsx(Flex, { justify: 'flex-end', children: _jsxs(Space, { size: [12, 20], wrap: true, children: [(objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.intIACert) === 2 ? (_jsxs(_Fragment, { children: [_jsx(Tooltip, { color: "#00A4A4", title: 'Delete Certificate', children: _jsx(DeleteOutlined, { style: { fontSize: '20px', color: 'red' }, onClick: deleteCertificate }) }), ((_7 = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objCertRenewalStatus) === null || _7 === void 0 ? void 0 : _7.intId) !== 6050 ? (_jsx(_Fragment, { children: _jsx(Tooltip, { color: "#00A4A4", title: 'Update Certificate', children: _jsx(EditFilled, { style: { fontSize: '20px', color: 'blue' }, onClick: handleUpdateCertificate }) }) })) : ('')] })) : (''), ((_8 = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objCertRenewalStatus) === null || _8 === void 0 ? void 0 : _8.intId) === 6010 &&
                                        ((_9 = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objCertStatus) === null || _9 === void 0 ? void 0 : _9.intId) !== 3 &&
                                        (objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.intIACert) !== 1 &&
                                        ((_10 = objCertDetails === null || objCertDetails === void 0 ? void 0 : objCertDetails.objCertStatus) === null || _10 === void 0 ? void 0 : _10.intId) !== 4 ? (_jsx(_Fragment, { children: _jsx(Tooltip, { color: "#00A4A4", title: 'Upload Renewal Certificate', children: _jsx(SyncOutlined, { style: { fontSize: '20px', color: 'green' }, onClick: linkRenewalCert }) }) })) : ('')] }) }) }), bordered: true, column: { xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }, items: loadingDesc ? loadingItems : items }), regLibList && regLibList.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsx(Typography.Title, { level: 5, style: { marginBottom: '18px' }, children: "Regulation Information" }), _jsx(CertificateDetailRLTable, { data: regLibList, msAccess: (_11 = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _11 === void 0 ? void 0 : _11.boolCertificateDetailsLinkedRegulatoryLibray, loading: isLoading, pagination: pagination, onChange: handleTableChange })] }))] }));
};
export default CertificateDetails;
